var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('top-bar',{ref:"top-bar",on:{"showModal":_vm.showModal}}),_c('router-view',{on:{"showModal":_vm.showModal}}),_c('page-bottom',{on:{"showModal":_vm.showModal}}),_c('form-modal',{ref:"form-modal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }